import ValidationItem from "./ValidationItem";
import ValidationMessage from "./ValidationMessage";

export default class ValidationResult {
  items: ValidationItem[];
  errorsVisible: boolean;

  constructor(items: ValidationItem[], errorsVisible: boolean) {
    this.items = items;
    this.errorsVisible = errorsVisible;
  }

  public isValid = (considerErrorsVisibleValue: boolean = true): boolean => {
    if (considerErrorsVisibleValue && !this.errorsVisible) {
      return true;
    }

    let isValid = true;

    for (let i = 0; i < this.items.length; i++) {
      if (this.items[i].messages.length > 0) {
        isValid = false;
        break;
      }
    }

    return isValid;
  };

  public getTrackerMessages = (
    trackerName: string,
    considerErrorsVisibleValue: boolean = true
  ) => {
    if (considerErrorsVisibleValue && !this.errorsVisible) {
      return [];
    }

    const trackerMessages = this.getMessages(trackerName);

    return trackerMessages;
  };

  public isTrackerValid = (trackerName: string) => {
    if (!this.errorsVisible) {
      return true;
    }

    if (this.getMessages(trackerName).length > 0) {
      return false;
    }

    return true;
  };

  public getPropertyMessages = (trackerName: string, propertyName: string) => {
    if (!this.errorsVisible) {
      return [];
    }

    const trackerMessages = this.getMessages(trackerName);
    const messages: ValidationMessage[] = [];

    trackerMessages.forEach(trackerMessage => {
      if (trackerMessage.propertyName === propertyName) {
        messages.push(trackerMessage);
      }
    });

    return messages;
  };

  public isPropertyValid = (trackerName: string, propertyName: string) => {
    if (!this.errorsVisible) {
      return true;
    }

    if (this.getPropertyMessages(trackerName, propertyName).length > 0) {
      return false;
    }

    return true;
  };

  public getArrayItemMessages = (trackerName: string, index: string) => {
    if (!this.errorsVisible) {
      return [];
    }

    const trackerMessages = this.getMessages(trackerName);
    const messages: ValidationMessage[] = [];

    trackerMessages.forEach(trackerMessage => {
      if (trackerMessage.index === index) {
        messages.push(trackerMessage);
      }
    });

    return messages;
  };

  public isArrayItemValid = (trackerName: string, index: string) => {
    if (!this.errorsVisible) {
      return true;
    }

    if (this.getArrayItemMessages(trackerName, index).length > 0) {
      return false;
    }

    return true;
  };

  public getArrayPropertyMessages = (
    trackerName: string,
    index: string,
    propertyName: string
  ) => {
    if (!this.errorsVisible) {
      return [];
    }

    const trackerMessages = this.getMessages(trackerName);
    const messages: ValidationMessage[] = [];

    trackerMessages.forEach(trackerMessage => {
      if (
        trackerMessage.index === index &&
        trackerMessage.propertyName === propertyName
      ) {
        messages.push(trackerMessage);
      }
    });

    return messages;
  };

  public isArrayPropertyValid = (
    trackerName: string,
    index: string,
    propertyName: string
  ) => {
    if (!this.errorsVisible) {
      return true;
    }

    if (
      this.getArrayPropertyMessages(trackerName, index, propertyName).length > 0
    ) {
      return false;
    }

    return true;
  };

  public getArrayPropertyWithParrentMessages = (
    trackerName: string,
    index: string,
    parentPropertyName: string,
    propertyName: string
  ) => {
    if (!this.errorsVisible) {
      return [];
    }

    const trackerMessages = this.getMessages(trackerName);
    const messages: ValidationMessage[] = [];

    trackerMessages.forEach(trackerMessage => {
      if (
        trackerMessage.index === index &&
        trackerMessage.parentPropertyName === parentPropertyName &&
        trackerMessage.propertyName === propertyName
      ) {
        messages.push(trackerMessage);
      }
    });

    return messages;
  };

  public isArrayPropertyWithParrentValid = (
    trackerName: string,
    index: string,
    parentPropertyName: string,
    propertyName: string
  ) => {
    if (!this.errorsVisible) {
      return true;
    }

    if (
      this.getArrayPropertyWithParrentMessages(
        trackerName,
        index,
        parentPropertyName,
        propertyName
      ).length > 0
    ) {
      return false;
    }

    return true;
  };

  private getMessages = (trackerName: string): ValidationMessage[] => {
    const trackerItems = this.items.filter(i => i.trackerName === trackerName);
    let trackerMessages: ValidationMessage[] = [];

    trackerItems.forEach(item => {
      item.messages.forEach(message => {
        trackerMessages.push(message);
      });
    });

    return trackerMessages;
  };
}
